import {setPaddingSection} from 'Client/utils/padding-section'
class WidgetPaddingBoxTimeline extends elementorModules.frontend.handlers.Base {
    getDefaultSettings() {
        return {
            selectors: {
                padding: '.box-timeline',
            },
        };
    }

    getDefaultElements() {
        const selectors = this.getSettings( 'selectors' );
        return {
            $padding: this.$element.find( selectors.padding ),
        };
    }

    bindEvents() {
        const THIS = this;
        const ELEMENT = this.elements.$padding[0];
        if(ELEMENT) {
            let dataPadding = ELEMENT.getAttribute('data-padding');
            let dataResponsive = ELEMENT.getAttribute('data-responsive')
            let obj_pd = JSON.parse(atob(dataPadding))
            let obj_responsive = JSON.parse(atob(dataResponsive))
            setPaddingSection(obj_pd, obj_responsive, ELEMENT);
        }
    } 
}

jQuery( window ).on( 'elementor/frontend/init', () => {
    const addHandler = ( $element ) => {
        elementorFrontend.elementsHandler.addHandler( WidgetPaddingBoxTimeline, {
            $element,
        } );
    };
    // efc_form_donate ->Name widget register in php
    elementorFrontend.hooks.addAction( 'frontend/element_ready/ecf_box_timeline.default', addHandler );
} );

